import React from 'react'
import { Route } from 'react-router-dom'
import MainInspection from '../Views/Web/Inspection/MainInspection'
import { CalendarCreate, CalendarEdit, CalendarView, CalenderMain, IndexCalender } from '../Views/Web/Inspection/Calender/Index'
import { FormOpen, IndexSchedule, NewForm, ScheduleCreate, ScheduleEdit, ScheduleFormView, ScheduleMain, ScheduleView } from '../Views/Web/Inspection/Schedule/Index'
import TaskIndex from '../Views/Web/Inspection/Schedule/IndexTask'
import ViewTask from '../Views/Web/Inspection/Schedule/ViewTask'


function InspectionRoutes() {
    return (
      <Route path="inspection" element={<MainInspection />}>
          <Route path="calender" element={<CalenderMain/>} >
           <Route index element={<IndexCalender/>} />
           <Route path='create' element={<CalendarCreate/>} />
           <Route path='edit/:calenderEditId' element={<CalendarEdit/>} />
           <Route path='view/:calenderViewId' element={<CalendarView/>} />
          </Route>
          <Route path="schedule" element={<ScheduleMain/>} >
           <Route index element={<IndexSchedule/>} />
           <Route path='create' element={<ScheduleCreate/>} />
           <Route path='edit/:scheduleEditId' element={<ScheduleEdit/>} />
           <Route path='view/:scheduleViewId' element={<ScheduleView/>} />
           <Route path='index/:scheduleViewId' element={<TaskIndex/>} />
           <Route path='viewtask/:scheduleViewId' element={<ViewTask/>} />
           <Route path='form/:scheduleViewId' element={<ScheduleFormView/>} />
           <Route path='newform/:scheduleViewId' element={<NewForm/>} />
           <Route path='formOpen/:scheduleViewId' element={<FormOpen/>} />

            
          </Route>
          
      </Route>
    )
  }
  
  export default InspectionRoutes